<div fxLayout="column" fxLayoutAlign="space-around center">
  <h2>{{title}}</h2>
  <div fxLayout="row" fxLayoutAlign="space-around center">
    <p>Activer</p>
    <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="enable" (ngModelChange)="changeValue()">
    </mat-slide-toggle>
  </div>
  <div>
    <audio controls
           [src]="url">
      Your browser does not support the
      <code>audio</code> element.
    </audio>
  </div>
  <div>
    <input class="inputFile" id="uploadSound" type="file" (change)="uploadSoundMedia($event)" #uploadSound name="sound" accept=".mp3" />
    <button (click)="triggerUpload()" mat-mini-fab><mat-icon>edit</mat-icon></button>
    <button [disabled]="url && url.length == 0" style="{z-index: 1;}" mat-mini-fab color="warn" (click)="removeSound('loop')">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
